// extracted by mini-css-extract-plugin
export var description = "QuickAction-module--description--cAptt";
export var disabled = "QuickAction-module--disabled--4X2oU";
export var iconWrapper = "QuickAction-module--iconWrapper--S4Sy2";
export var quickAction = "QuickAction-module--quickAction--yuZ6p";
export var quickActionWrap = "QuickAction-module--quickActionWrap--Tk+dP";